
import FooterTitle from "@/components/layout/footerTitle.vue";

export default {
  name: "LayoutFooters",
  components: {FooterTitle}
}
